import { Fragment, useEffect, useState } from 'react';
import { Container } from '@/components/container';
import {
    Toolbar,
    ToolbarActions,
    ToolbarDescription,
    ToolbarHeading,
    ToolbarPageTitle,
} from '@/partials/toolbar';
import { PageNavbar } from '@/pages/account';
import { MatchesContent } from './MatchesContent.tsx';
import { KeenIcon } from '@/components';
import axios from 'axios';
import { MatchDetailsData } from '@/pages/buddy/types/MatchDetailsData';
import { useParams } from "react-router-dom";
import {enqueueSnackbar} from "notistack";

const MatchesPage = () => {
    const [matches, setMatches] = useState<MatchDetailsData[]>([]);
    const [newMatchModalOpen, setNewMatchModalOpen] = useState(false);
    const handleOpen = () => setNewMatchModalOpen(true);
    const handleClose = () => setNewMatchModalOpen(false);
    const { tab } = useParams<{ tab?: string }>();
    const [activePage, setActivePage] = useState<string>(tab || 'overview'); // Default to 'overview'

    // Loading and error management
    const [loading, setLoading] = useState(true);

    // API Endpoints
    const API_MATCHES = `${import.meta.env.VITE_APP_API_URL}/matches`;
    const API_MATCH = `${import.meta.env.VITE_APP_API_URL}/match`;

    const fetchMatchData = async () => {
        setLoading(true); // Set loading state to true at the beginning of the fetch
        try {
            const response = await axios.get<MatchDetailsData[]>(API_MATCHES, {
                headers: {
                    Accept: 'application/json',
                },
            });

            setMatches(response.data);

            // Auto-open modal if no companies are returned
            if (response.data.length === 0) {
                handleOpen();
            }

        } catch (err) {
            enqueueSnackbar(`Failed to fetch matches data: ${err}`, {
                variant: 'solid',
                state: 'danger'
            });
        } finally {
            setLoading(false); // Ensure loading is false after the fetch
        }
    };

    const handleConfirmDeleteMatch = async (companyId: string) => {
        try {
            await axios.delete(`${API_MATCH}/${companyId}`, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            fetchMatchData(); // Refresh the company list after deletion
            enqueueSnackbar('The company has been successfully deleted.', {
                variant: 'solid',
                state: 'success'
            });
        } catch (err) {
            enqueueSnackbar(`Failed to delete the company: ${err}`, {
                variant: 'solid',
                state: 'danger'
            });
        }
    };

    // Fetch matches data on mount
    useEffect(() => {
        fetchMatchData();
    }, []);

    return (
        <Fragment>
            <PageNavbar />

            {/*<NewMatchModal open={newMatchModalOpen} onClose={handleClose} />*/}

            <Container>
                <Toolbar>
                    <ToolbarHeading>
                        <ToolbarPageTitle />
                        <ToolbarDescription>
                            View all matches to organize and manage their jobs, simplifying the process of sorting and
                            matching candidates to specific roles.
                        </ToolbarDescription>
                    </ToolbarHeading>
                    <ToolbarActions>
                        <button onClick={handleOpen} type="button" className="btn btn-sm btn-primary">
                            <KeenIcon icon="plus" /> Add New Match
                        </button>
                    </ToolbarActions>
                </Toolbar>
            </Container>

            <Container>
                <MatchesContent
                    matches={matches}
                    loading={loading}
                    on_delete={handleConfirmDeleteMatch} // Pass the delete function to MatchesContent
                />
            </Container>
        </Fragment>
    );
};

export { MatchesPage };
